import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=23fef89a&scoped=true&"
import script from "./UserManage.vue?vue&type=script&lang=js&"
export * from "./UserManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fef89a",
  null
  
)

export default component.exports